import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OfflineProductComponent } from './components/product-details/offline-product.component';
import { ProductsComponent } from './components/products.component';
import { ProductsResolver } from './services/resolvers/products-resolver.service';

const routes: Routes = [
    { path: '', component: ProductsComponent },
    {
        path: 'product-details/:id',
        component: OfflineProductComponent,
        resolve: {
            product: ProductsResolver
        }
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class OfflineShopAdminRoutingModule {
}
